import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouCreate() {
  const products = [{
    name: 'Collares premium personalizados',
    icon: '🐕'
  }, {
    name: 'Correas de paracord',
    icon: '🪢'
  }, {
    name: 'Sogas resistentes',
    icon: '🧶'
  }, {
    name: 'Bandanas artesanales',
    icon: '🧣'
  }, {
    name: 'Accesorios premium para perros',
    icon: '✨'
  }];
  return <section className="py-10 px-4 bg-white" data-id="element-299">
      <div className="max-w-5xl mx-auto text-center" data-id="element-300">
        <div className="inline-flex items-center gap-2 bg-brand-100 text-brand-800 px-4 py-1.5 rounded-full font-semibold text-sm mb-3" data-id="element-301">
          🐶 Inspiración Artesanal
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-302">
          Lo que vas a poder crear
        </h2>
        <p className="text-base text-slate-600 mb-6 max-w-2xl mx-auto" data-id="element-303">
          Diseños modernos, fáciles de fabricar y altamente vendibles.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-304">
          {products.map((product, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-slate-50 rounded-2xl p-4 border border-slate-100 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center gap-2" data-id="element-305">
              <div className="text-3xl bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-306">
                {product.icon}
              </div>
              <h3 className="font-bold text-slate-800 text-lg" data-id="element-307">
                {product.name}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}